import SignUpConfirmSuccess from './SignUpConfirmSuccess';

export default SignUpConfirmSuccess;
